import { BoatData, insurance_package } from '@ahoy/types/billing';

export const insuracePackageFromPackageData: Record<string, object | string> = {
  'BI_Bodily_Injury_Liability': 'BI_Bodily_Injury_Liability_YN',
  'PD_Property_Damage_Liability': 'PD_Property_Damage_Liability_YN',
  'MP_Medical_Payments': 'MP_Medical_Payments_YN',
  'UBUIBBI_Uninsured_Underinsured_Boater': 'UBUIBBI_Uninsured_Underinsured_Boater_YN',
  'TL_On_Water_Towing': 'TL_On_Water_Towing_YN',
  'FSHEQ_Fishing_Equipment': 'FSHEQ_Fishing_Equipment_YN',
  'PEREF_Personal_Effects': 'PEREF_Personal_Effects_YN',
  'Package': 'package',
  'Premium': {
    'annual-amount': 'TotalPremiumAnnualy',
    'monthly-amount': 'TotalPremiumMonthly',
  },
  'Is_Package_Customized': 'Is_Package_Customized',
  'Physical_Damage_Settlement_option': 'Physical_Damage_Settlement_option',
  'COLL_Coverage_Deductible_Amount': 'COLL_Coverage_Deductible_Amount',
  'COMP_Coverage_Deductible_Amount': 'COMP_Coverage_Deductible_Amount',
  'BI_Limit_per_occurrence': 'BI_Limit_per_occurrence',
  'BI_Limit_per_person': 'BI_Limit_per_person',
  'PD_Limit_per_occurrence': 'PD_Limit_per_occurrence',
  'MP_Limit_per_occurrence': 'MP_Limit_per_occurrence',
  'UBUBBI_Limit_per_occurrence': 'UBUBBI_Limit_per_occurrence',
  'UBUBBI_Limit_per_person': 'UBUBBI_Limit_per_person',
  'TL_Limit_per_occurrence': 'TL_Limit_per_occurrence',
  'FSHEQ_Limit_per_occurrence': 'FSHEQ_Limit_per_occurrence',
  'PEREF_Limit_per_occurrence': 'PEREF_Limit_per_occurrence',
  'RSA_Roadside_Assistance': 'RSA_Roadside_Assistance_YN',
  'UBUIBPD': 'UBUIBPD_Limit_YN',
  'UBUIBPD_Limit': 'UBUIBPD_Limit',
  'Family_Bodily_Injury':'Family_Bodily_Injury_YN',
  'RENTRE_Rental_Reimbursement': 'RENTRE_Rental_Reimbursement_YN',
};

export const tierDummyDataForCoverages: BoatData[] = [{
  'package': 'Tier 1',
  'TotalPremiumMonthly': 450,
  'TotalPremiumAnnualy': 450,
  'Is_Package_Customized': '$_BOOL_false',
  'Physical_Damage_Settlement_option': 'Actual Cash Value',
  'COLL_Coverage_Deductible_YN': '$_BOOL_true',
  'COLL_Coverage_Deductible_Amount': 100,
  'COMP_Coverage_Deductible_YN': '$_BOOL_true',
  'COMP_Coverage_Deductible_Amount': 250,
  'BI_Limit_per_occurrence': 300000,
  'BI_Limit_per_person': 100000,
  'PD_Limit_per_occurrence': 300000,
  'MP_Limit_per_occurrence': 2000,
  'UBUBBI_Limit_per_occurrence': 300000,
  'UBUBBI_Limit_per_person': 100000,
  'TL_Limit_per_occurrence': 100,
  'FSHEQ_Limit_per_occurrence': 2500,
  'PEREF_Limit_per_occurrence': 8000,
  'BI_Bodily_Injury_Liability_YN': '$_BOOL_true',
  'PD_Property_Damage_Liability_YN': '$_BOOL_true',
  'MP_Medical_Payments_YN': '$_BOOL_true',
  'UBUIBBI_Uninsured_Underinsured_Boater_YN': '$_BOOL_true',
  'TL_On_Water_Towing_YN': '$_BOOL_true',
  'PEREF_Personal_Effects_YN': '$_BOOL_true',
  'FSHEQ_Fishing_Equipment_YN': '$_BOOL_true',
  'RSA_Roadside_Assistance_YN': '$_BOOL_true',
  'UBUIBPD_Limit_YN': '$_BOOL_true',
  'UBUIBPD_Limit': 100000,
  'Family_Bodily_Injury_YN':'$_BOOL_true',
  'RENTRE_Rental_Reimbursement_YN': '$_BOOL_true',
  'boatName': 'Green Rabit',
  'boatStatus': 'Incomplete',
  'appId': '1',
}, {
  'package': 'Tier 2',
  'TotalPremiumMonthly': 500,
  'TotalPremiumAnnualy': 500,
  'Is_Package_Customized': '$_BOOL_true',
  'Physical_Damage_Settlement_option': 'Actual Cash Value',
  'COLL_Coverage_Deductible_YN': '$_BOOL_true',
  'COLL_Coverage_Deductible_Amount': 100,
  'COMP_Coverage_Deductible_YN': '$_BOOL_true',
  'COMP_Coverage_Deductible_Amount': 250,
  'BI_Limit_per_occurrence': 300000,
  'BI_Limit_per_person': 100000,
  'PD_Limit_per_occurrence': 300000,
  'MP_Limit_per_occurrence': 2000,
  'UBUBBI_Limit_per_occurrence': 300000,
  'UBUBBI_Limit_per_person': 100000,
  'TL_Limit_per_occurrence': 100,
  'FSHEQ_Limit_per_occurrence': 2500,
  'PEREF_Limit_per_occurrence': 8000,
  'BI_Bodily_Injury_Liability_YN': '$_BOOL_true',
  'PD_Property_Damage_Liability_YN': '$_BOOL_true',
  'MP_Medical_Payments_YN': '$_BOOL_true',
  'UBUIBBI_Uninsured_Underinsured_Boater_YN': '$_BOOL_true',
  'TL_On_Water_Towing_YN': '$_BOOL_true',
  'PEREF_Personal_Effects_YN': '$_BOOL_true',
  'FSHEQ_Fishing_Equipment_YN': '$_BOOL_true',
  'RSA_Roadside_Assistance_YN': '$_BOOL_true',
  'UBUIBPD_Limit_YN': '$_BOOL_true',
  'UBUIBPD_Limit': 300000,
  'Family_Bodily_Injury_YN':'$_BOOL_true',
  'RENTRE_Rental_Reimbursement_YN': '$_BOOL_true',
  'boatName': 'Blue Rabit',
  'boatStatus': 'Customized',
  'appId': '2',
}, {
  'package': 'Tier 3',
  'TotalPremiumMonthly': 550,
  'TotalPremiumAnnualy': 550,
  'Is_Package_Customized': '$_BOOL_false',
  'Physical_Damage_Settlement_option': 'Actual Cash Value',
  'COLL_Coverage_Deductible_YN': '$_BOOL_true',
  'COLL_Coverage_Deductible_Amount': 100,
  'COMP_Coverage_Deductible_YN': '$_BOOL_true',
  'COMP_Coverage_Deductible_Amount': 250,
  'BI_Limit_per_occurrence': 300000,
  'BI_Limit_per_person': 100000,
  'PD_Limit_per_occurrence': 300000,
  'MP_Limit_per_occurrence': 2000,
  'UBUBBI_Limit_per_occurrence': 300000,
  'UBUBBI_Limit_per_person': 100000,
  'TL_Limit_per_occurrence': 100,
  'FSHEQ_Limit_per_occurrence': 2500,
  'PEREF_Limit_per_occurrence': 8000,
  'BI_Bodily_Injury_Liability_YN': '$_BOOL_true',
  'PD_Property_Damage_Liability_YN': '$_BOOL_true',
  'MP_Medical_Payments_YN': '$_BOOL_true',
  'UBUIBBI_Uninsured_Underinsured_Boater_YN': '$_BOOL_true',
  'TL_On_Water_Towing_YN': '$_BOOL_true',
  'PEREF_Personal_Effects_YN': '$_BOOL_true',
  'FSHEQ_Fishing_Equipment_YN': '$_BOOL_true',
  'RSA_Roadside_Assistance_YN': '$_BOOL_true', 
  'UBUIBPD_Limit_YN': '$_BOOL_true',
  'UBUIBPD_Limit': 500000,
  'Family_Bodily_Injury_YN':'$_BOOL_true',
  'RENTRE_Rental_Reimbursement_YN': '$_BOOL_true',
  'boatName': 'Red Rabit',
  'boatStatus': 'UW error',
  'appId': '3',
}];
export const tierDummyData: insurance_package[] = [{
  'package': 'Tier 1',
  'TotalPremiumMonthly': 450,
  'TotalPremiumAnnualy': 450,
  'Is_Package_Customized': '$_BOOL_false',
  'Physical_Damage_Settlement_option': 'Actual Cash Value',
  'COLL_Coverage_Deductible_YN': '$_BOOL_true',
  'COLL_Coverage_Deductible_Amount': 100,
  'COMP_Coverage_Deductible_YN': '$_BOOL_true',
  'COMP_Coverage_Deductible_Amount': 250,
  'BI_Limit_per_occurrence': 300000,
  'BI_Limit_per_person': 100000,
  'PD_Limit_per_occurrence': 300000,
  'MP_Limit_per_occurrence': 2000,
  'UBUBBI_Limit_per_occurrence': 300000,
  'UBUBBI_Limit_per_person': 100000,
  'TL_Limit_per_occurrence': 100,
  'FSHEQ_Limit_per_occurrence': 2500,
  'PEREF_Limit_per_occurrence': 8000,
  'BI_Bodily_Injury_Liability_YN': '$_BOOL_true',
  'PD_Property_Damage_Liability_YN': '$_BOOL_true',
  'MP_Medical_Payments_YN': '$_BOOL_true',
  'UBUIBBI_Uninsured_Underinsured_Boater_YN': '$_BOOL_true',
  'TL_On_Water_Towing_YN': '$_BOOL_true',
  'PEREF_Personal_Effects_YN': '$_BOOL_true',
  'FSHEQ_Fishing_Equipment_YN': '$_BOOL_true',
  'RSA_Roadside_Assistance_YN': '$_BOOL_true',
  'RENTRE_Rental_Reimbursement_YN': '$_BOOL_true',
  'UBUIBPD_Limit_YN': '$_BOOL_true',
  'UBUIBPD_Limit': 100000,
  'Family_Bodily_Injury_YN':'$_BOOL_true',
}, {
  'package': 'Tier 2',
  'TotalPremiumMonthly': 500,
  'TotalPremiumAnnualy': 500,
  'Is_Package_Customized': '$_BOOL_false',
  'Physical_Damage_Settlement_option': 'Actual Cash Value',
  'COLL_Coverage_Deductible_YN': '$_BOOL_true',
  'COLL_Coverage_Deductible_Amount': 100,
  'COMP_Coverage_Deductible_YN': '$_BOOL_true',
  'COMP_Coverage_Deductible_Amount': 250,
  'BI_Limit_per_occurrence': 100000,
  'BI_Limit_per_person': 100000,
  'PD_Limit_per_occurrence': 300000,
  'MP_Limit_per_occurrence': 2000,
  'UBUBBI_Limit_per_occurrence': 100000,
  'UBUBBI_Limit_per_person': 100000,
  'TL_Limit_per_occurrence': 100,
  'FSHEQ_Limit_per_occurrence': 2500,
  'PEREF_Limit_per_occurrence': 8000,
  'BI_Bodily_Injury_Liability_YN': '$_BOOL_true',
  'PD_Property_Damage_Liability_YN': '$_BOOL_true',
  'MP_Medical_Payments_YN': '$_BOOL_true',
  'UBUIBBI_Uninsured_Underinsured_Boater_YN': '$_BOOL_true',
  'TL_On_Water_Towing_YN': '$_BOOL_true',
  'PEREF_Personal_Effects_YN': '$_BOOL_true',
  'FSHEQ_Fishing_Equipment_YN': '$_BOOL_true',
  'RSA_Roadside_Assistance_YN': '$_BOOL_true',
  'RENTRE_Rental_Reimbursement_YN': '$_BOOL_true',
  'UBUIBPD_Limit_YN': '$_BOOL_true',
  'UBUIBPD_Limit': 300000,
  'Family_Bodily_Injury_YN':'$_BOOL_true',
}, {
  'package': 'Tier 3',
  'TotalPremiumMonthly': 550,
  'TotalPremiumAnnualy': 550,
  'Is_Package_Customized': '$_BOOL_false',
  'Physical_Damage_Settlement_option': 'Actual Cash Value',
  'COLL_Coverage_Deductible_Amount': 100,
  'COLL_Coverage_Deductible_YN': '$_BOOL_true',
  'COMP_Coverage_Deductible_YN': '$_BOOL_true',
  'COMP_Coverage_Deductible_Amount': 250,
  'BI_Limit_per_occurrence': 100000,
  'BI_Limit_per_person': 100000,
  'PD_Limit_per_occurrence': 300000,
  'MP_Limit_per_occurrence': 2000,
  'UBUBBI_Limit_per_occurrence': 100000,
  'UBUBBI_Limit_per_person': 100000,
  'TL_Limit_per_occurrence': 100,
  'FSHEQ_Limit_per_occurrence': 2500,
  'PEREF_Limit_per_occurrence': 10000,
  'BI_Bodily_Injury_Liability_YN': '$_BOOL_true',
  'PD_Property_Damage_Liability_YN': '$_BOOL_true',
  'MP_Medical_Payments_YN': '$_BOOL_true',
  'UBUIBBI_Uninsured_Underinsured_Boater_YN': '$_BOOL_true',
  'TL_On_Water_Towing_YN': '$_BOOL_true',
  'PEREF_Personal_Effects_YN': '$_BOOL_true',
  'FSHEQ_Fishing_Equipment_YN': '$_BOOL_true',
  'RSA_Roadside_Assistance_YN': '$_BOOL_true',
  'RENTRE_Rental_Reimbursement_YN': '$_BOOL_true',
  'UBUIBPD_Limit_YN': '$_BOOL_true',
  'UBUIBPD_Limit': 500000,
  'Family_Bodily_Injury_YN':'$_BOOL_true',
}];

export const animationDelay = 300;